module.exports = __webpack_public_path__ + "img/197.a46db9e4.jpg";